module.exports = __webpack_public_path__ + "assets/update-role.17a3bd6d.svg";